'use client';
import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import CustomerLoginForm from './components/CustomerLoginForm';

export default function CustomerLoginPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-emerald-50 flex flex-col">
      {/* Header */}
      <header className="px-6 py-4 flex items-center justify-between max-w-screen-xl mx-auto w-full">
        <Link href="/" className="flex items-center gap-2 group">
          <AppLogo size={32} />
          <span className="font-700 text-foreground text-lg">Bozaat</span>
        </Link>
        <p className="text-sm text-muted-foreground">
          New customer?{' '}
          <Link href="/customer-sign-up" className="text-primary font-600 hover:underline">
            Create account
          </Link>
        </p>
      </header>

      {/* Main */}
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <div className="w-14 h-14 bg-primary/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <AppLogo size={32} />
            </div>
            <h1 className="text-2xl font-700 text-foreground">Welcome back</h1>
            <p className="text-sm text-muted-foreground mt-1">Sign in to your Bozaat account</p>
          </div>
          <CustomerLoginForm />
          <p className="text-center text-xs text-muted-foreground mt-6">
            Are you a seller?{' '}
            <Link href="/seller-login" className="text-primary hover:underline font-600">
              Seller Login
            </Link>
          </p>
        </div>
      </main>
    </div>
  );
}
